import types from './types'

const fetchingTrainingAttempts = () => ({ type: types.FETCH_TRAINING_ATTEMPTS })

const fetchingTrainingAttemptsError = error => ({
  type: types.FETCH_TRAINING_ATTEMPTS_ERROR,
  error,
})

const fetchingTrainingAttemptsSuccess = (
  siteId,
  licenseId,
  program,
  trainingData,
) => ({
  type: types.FETCH_TRAINING_ATTEMPTS_SUCCESS,
  siteId,
  licenseId,
  program,
  trainingData,
})

const fetchingTrainingCompletion = () => ({
  type: types.FETCH_TRAINING_COMPLETION,
})

const fetchingTrainingCompletionError = error => ({
  type: types.FETCH_TRAINING_COMPLETION_ERROR,
  error,
})

const fetchingTrainingCompletionSuccess = (siteId, completionData) => ({
  type: types.FETCH_TRAINING_COMPLETION_SUCCESS,
  siteId,
  completionData,
})

export default {
  fetchingTrainingAttempts,
  fetchingTrainingAttemptsError,
  fetchingTrainingAttemptsSuccess,
  fetchingTrainingCompletion,
  fetchingTrainingCompletionError,
  fetchingTrainingCompletionSuccess,
}
